import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import "../assets/css/newstudent.css";
import { newsItems } from "../components/Data/newsItem";

import anaestheticImg from "../assets/images/anaesthetic.jpg";
import communityImg from "../assets/images/community.jpg";
import biomedicalImg from "../assets/images/biomedical.jpg";
import healthinfoImg from "../assets/images/healthinfo.jpg";
import socialworkImg from "../assets/images/socialwork.jpg";
import nursingImg from "../assets/images/nursing.jpg";
import postbasicImg from "../assets/images/postbasic.jpg";
import midwiferyImg from "../assets/images/midwifery.jpg";

import Navbar from "../components/Navbar";
import SchoolHeroSlider from "../components/SchoolHeroSlider";
import NewsCarousel from "../components/newsCarousel";
import Footer from "../components/Footer";

const schools = [
  { name: "Anaesthetic Technicians", key: "anaesthetic", img: anaestheticImg },
  { name: "School of Community Health", key: "community", img: communityImg },
  {
    name: "Federal School of Biomedical Engineering",
    key: "biomedical",
    img: biomedicalImg,
  },
  {
    name: "School of Health Information Management",
    key: "healthinfo",
    img: healthinfoImg,
  },
  {
    name: "School of Medical and Psychiatry Social Work",
    key: "socialwork",
    img: socialworkImg,
  },
  {
    name: "College of Nursing Sciences",
    key: "nursing",
    img: nursingImg,
  },
];

const NewStudents = () => {
  const navigate = useNavigate();
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    setShowPopup(true);
  }, []);

  return (
    <>
      <Navbar />
      <div className="newstudents-wrapper">
        {SchoolHeroSlider && (
          <SchoolHeroSlider
            slides={schools}
            onViewInstructions={() => setShowPopup(true)}
          />
        )}

        <div className="school-info-section">
          <h1>Apply to our current schools and their programs</h1>
          <p className="school-card-description">
            Click a school below to view available programmes.
            <br />
            <h3>
              For School of Post Basic Nursing, Check under College of Nursing
              Sciences
            </h3>
          </p>

          <button
            className="instruction-btn"
            onClick={() => setShowPopup(true)}
          >
            📄 View Instructions
          </button>
        </div>

        <div className="school-card-container">
          {schools.map((school) => (
            <div
              key={school.key}
              className="school-card"
              onClick={() =>
                navigate(`/school/${school.key}`, {
                  state: { schoolName: school.name },
                })
              }
            >
              <img src={school.img} alt={school.name} />
              <div className="school-card-content">
                <h2>{school.name}</h2>
                <button>View Programmes</button>
              </div>
            </div>
          ))}
        </div>

        <div className="news-section">
          <div className="news-section-intro">
            <h1
              style={{
                fontSize: "48px",
                fontWeight: "bold",
                textAlign: "center",
                color: "#d1d1d1ff",
                marginBottom: "20px",
              }}
            >
              Recent News
            </h1>
            <p>
              Stay informed with the latest news and updates from LUTH Schools.
            </p>
          </div>

          <div className="news-section-header">
            <NewsCarousel
              items={newsItems}
              itemsPerSlide={4}
              onSlideChange={(i) => console.log("picked slide", i)}
            />
          </div>

          <div className="news-section-footer">
            <button
              className="instruction-btn"
              onClick={() => navigate("/news")}
            >
              View All News
            </button>
          </div>
        </div>

        <div className="newstudents-footer">{Footer && <Footer />}</div>

        {showPopup && (
          <div className="admission-popup-overlay">
            <div className="admission-popup">
              <h2
                style={{
                  fontSize: "24px",
                  fontWeight: "bold",
                  textAlign: "center",
                  color: "#333",
                  marginBottom: "5px",
                  marginTop: "20px",
                  padding: "10px",
                  backgroundColor: "#f4f4f4",
                }}
              >
                LAGOS UNIVERSITY TEACHING HOSPITAL, LAGOS NIGERIA
              </h2>
              <h3
                style={{
                  fontSize: "18px",
                  fontWeight: "bold",
                  textAlign: "center",
                }}
              >
                2026/2027 ADMISSIONS
              </h3>

              <div className="admission-popup-content">
                <p>
                  <br />
                  Applications are hereby invited from qualified candidates for
                  admission into the following Schools of the Lagos University
                  Teaching Hospital (LUTH), Idi-Araba, Lagos, Nigeria:
                </p>

                <p>
                  1. COLLEGE OF NURSING SCIENCES - (Basic) - ND/HND — Minumum
                  Admissible JAMB Score 200
                  <br />
                  2. SCHOOL OF HEALTH INFORMATION MANAGEMENT - ND/HND - Minimum
                  Admissible JAMB Score 160
                  <br />
                  3. FEDERAL SCHOOL OF BIOMEDICAL ENGINEERING - ND/HND - Minimum
                  Admissible JAMB Score 160
                  <br />
                  <strong>
                    Interested candidates should note that admission into
                    Schools 1–3 listed above requires participation in the
                    current Joint Admissions and Matriculation Board (JAMB)
                    Examination and attainment of the Minimum Admissible Score
                    specified for each school.
                  </strong>
                  <br />
                  4. SCHOOL OF POST BASIC NURSING: - 12 MONTHS PROGRAMME
                  <br />
                  <span
                    style={{
                      fontWeight: "bold",
                      fontSize: "14px",
                      lineHeight: "1.5",
                      marginLeft: "20px",
                    }}
                  >
                    a. Perioperative Nursing Programme
                  </span>
                  <br />
                  <span
                    style={{
                      fontWeight: "bold",
                      fontSize: "14px",
                      lineHeight: "1.5",
                      marginLeft: "20px",
                    }}
                  >
                    b. Accident and Emergency Nursing Programme
                  </span>
                  <br />
                  <span
                    style={{
                      fontWeight: "bold",
                      fontSize: "14px",
                      lineHeight: "1.5",
                      marginLeft: "20px",
                    }}
                  >
                    c. Paediatrics Nursing Programme
                  </span>
                  <br />
                  <span
                    style={{
                      fontWeight: "bold",
                      fontSize: "14px",
                      lineHeight: "1.5",
                      marginLeft: "20px",
                    }}
                  >
                    d. Ophthalmic Nursing Programme
                  </span>
                  <br />
                  <span
                    style={{
                      fontWeight: "bold",
                      fontSize: "14px",
                      lineHeight: "1.5",
                      marginLeft: "20px",
                    }}
                  >
                    e. Neonatal Nursing Programme
                  </span>
                  <br />
                  <span
                    style={{
                      fontWeight: "bold",
                      fontSize: "14px",
                      lineHeight: "1.5",
                      marginLeft: "20px",
                    }}
                  >
                    f. Nephrology Nursing Programme
                  </span>
                  <br />
                  <span
                    style={{
                      fontWeight: "bold",
                      fontSize: "14px",
                      lineHeight: "1.5",
                      marginLeft: "20px",
                    }}
                  >
                    g. Critical Care Nursing Programme
                  </span>
                  <br />
                  <span
                    style={{
                      fontWeight: "bold",
                      fontSize: "14px",
                      lineHeight: "1.5",
                      marginLeft: "20px",
                    }}
                  >
                    h. Dental Nursing Programme
                  </span>
                  <br />
                  5. School Of Community Health - Higher Diploma
                  <br />
                  <span
                    style={{
                      fontWeight: "bold",
                      fontSize: "14px",
                      lineHeight: "1.5",
                      marginLeft: "20px",
                    }}
                  >
                    i. One Year Higher Diploma in Community Health
                  </span>
                  <br />
                  <span
                    style={{
                      fontWeight: "bold",
                      fontSize: "14px",
                      lineHeight: "1.5",
                      marginLeft: "20px",
                    }}
                  >
                    ii. Two Years Higher Diploma in Community Health
                  </span>
                  <br />
                  6. SCHOOL OF MEDICAL AND PSYCHIATRY SOCIAL WORK - Postgraduate
                  Certificate
                  <br />
                  7. SCHOOL OF ANAESTHETIC TECHNICIANS - Diploma Certificate
                </p>

                <p>
                  <strong>METHOD OF APPLICATION</strong>
                  <br />
                  Interested candidates are to visit the Admission Portal:
                  https://schools.luth.gov.ng and click the school of interest
                  for detailed information.
                  <br />
                  <br />
                  i. Please ensure to read and adhere strictly to the admission
                  requirements carefully before completing the account creation
                  form of the school of interest to avoid disqualification.
                  <br />
                  <br />
                  ii. Complete the account creation form. Ensure you supply
                  correct information, a functional email address and phone
                  contacts as required. An email containing your login details
                  will be sent to you after the account creation. Through the
                  email, you will receive information on how to make payments
                  immediately or within 24 hours; failure to do so will require
                  you to re-register.
                  <br />
                  <br />
                  iii. If you desire to make a payment immediately, a prompt to
                  “Make payment” will be highlighted after the account creation.
                  <br />
                  <br />
                  iv. i. You will be redirected to the Remita website, where you
                  can make a payment. A Remita Retrieval Reference (RRR) code
                  automatically generated when your account was created will be
                  attached. Please note that various means of payment are
                  supported on the platform.
                  <br />
                  <br />
                  v. On successful completion of the payment, the applicant
                  should visit: https://schools.luth.gov.ng and click on login
                  at the top right corner, then login with the user ID sent
                  through email and complete the application form for the
                  desired programme.
                </p>
                <br />
                <p>
                  <strong>
                    NOTE: APPLICANTS MUST PRINT OUT THEIR COMPLETED ONLINE
                    APPLICATION BIO—DATA (COLOURED) WHICH IS SENT TO THEIR EMAIL
                    ON COMPLETION OF THE APPLICATION. SHORTLISTED CANDIDATES
                    WILL BE REQUIRED TO PRESENT THIS DURING THE ENTRANCE
                    EXAMINATIONS.
                  </strong>
                  <br />
                  <br />
                  <strong>Closing Date:</strong> Twelve (12) weeks from the date
                  of publication for all schools, except for the three schools
                  under the Joint Admissions and Matriculation Board JAMB.
                  <br />
                  For further enquiries, please contact the LUTH Schools
                  Administration Department on 07053736974, 09134465288 between
                  9:00 a.m. and 4:00 p.m. on working days, or via email at
                  info@luth.gov.ng and schadmin@luthschools.edu.ng
                </p>

                <p style={{ fontWeight: "bold", textAlign: "center" }}>
                  OMOLOLA O. FAKEYE (JP)
                  <br />
                  DIRECTOR OF ADMINISTRATION
                  <br />
                  FOR: CHIEF MEDICAL DIRECTOR
                </p>
              </div>

              <button
                className="admission-close-popup"
                onClick={() => setShowPopup(false)}
              >
                Close
              </button>
              <button
                style={{ marginLeft: "10px" }}
                className="admission-close-popup"
                onClick={() => {
                  setShowPopup(false);
                  navigate("/post-utme-calendar");
                }}
              >
                View Post-UTME/ Entrance Examination Dates 📅
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default NewStudents;
